import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import SatInput from '@components/common/satUI/SatInput';
import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';
import ChangeCustomerEmail from '@components/ea/ChangeCustomerEmail';
import LosContactButton from './elements/LosContactButton';
import { isNil } from '@common/utils';

const ContactInfo = ({
  //mobileTelNo = '',
  emailAddr = '',
  homeTelNo = '',
  wkplTelNo = '',
  errorObj = {},
  onChange,
  sendCustomerInfoModifyUrl = () => {},
  // beforeCustomerInfoDTO,
  customerInfo,
}) => {
  const { name, custNo, mobileTelNo, custKind, policyType } = customerInfo;
  const { error: toastError } = $hooks.useToast();

  const emailRef = useRef();
  const [emailPopupVisible, setEmailPopupVisible] = useState(false);

  const dispatch = useDispatch();
  const [customerModifySmsParamObject, setCustomerModifySmsParamObject] = useState(
    {
      custNo: custNo,
      mobileTelNo: mobileTelNo,
    },
  );
  const [isCustomerModifytSendSms, setCustomerModifySendSms] = useState(false);

  useEffect(() => {
    if (!emailPopupVisible) emailRef?.current?.onBlur();
  }, [emailPopupVisible]);

  const handleInputEmailAddr = value => {
    setEmailPopupVisible(false);
    onChange({ emailAddr: value });
  };

  const handleChange = (type, value) => onChange({ [type]: value });

  const isLP = $utils.checkLP(customerInfo?.orgChnlCd);
  const isContractCustomer = policyType !== '가망';
  const isCorporate = custKind === 'C';

  // hanjy: 고객구분이 '본인' 조건 추가
  // Robin: 본인에서, 가망이 아닌 것으로 변경 (계약고객: 본인, 감사 등 존재) [Tablet/Mobile 로직 통일용]
  // const isContactReadOnly = (isLP || isCorporate) && isContractCustomer;
  // Robin: Track2에서 계약고객도 고객정보 수정 가능하도록 변경
  const isContactReadOnly = false;
  const isRemoteUpdateAvailable = isLP && !isCorporate && isContractCustomer;

  const handleSmsSend = () => {
    setCustomerModifySendSms(true);
  };

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2 className="tit-con">연락처</h2>

        <div className="side-r d-flex-center flex-gap">
          {/* @NOTE: 푸르덴셜 설계사의 LP 고객인 경우만 버튼 노출 */}
          {isRemoteUpdateAvailable && (
            <>
              <p className="text-info ico-type">
                고객님이 직접 정보를 변경하실 수 있도록 SMS를 발송합니다.
              </p>

              <SatButton
                label="고객 정보 변경 SMS 발송"
                styleClass="btn-s blue kakaoBtn w-180 "
                iconStyleClass="ico ico-kakao2"
                onClick={handleSmsSend}
              />
            </>
          )}

          <LosContactButton customerInfo={customerInfo} />
        </div>
      </div>

      <div className="box two">
        <SatInput label={'휴대전화'} value={mobileTelNo} readOnly useMobile />
        <SatInput
          readOnly={isContactReadOnly}
          ref={emailRef}
          label={'이메일'}
          value={emailAddr || ''}
          onClick={() => setEmailPopupVisible(true)}
          suffix={() =>
            !isContactReadOnly && (
              <SatButton
                styleClass="ico ico-edit"
                onClick={() => setEmailPopupVisible(true)}
              />
            )
          }
          customStyleClass={errorObj.email ? 'error' : ''}
          onChange={value => handleChange('emailAddr', value)}
        />
      </div>
      <div className="box two">
        <SatInput
          readOnly={isContactReadOnly}
          type={'number'}
          label={'자택전화'}
          value={homeTelNo}
          format="phone"
          useMobile
          onChange={value => handleChange('homeTelNo', value)}
        />
        <SatInput
          useMobile
          readOnly={isContactReadOnly}
          type={'number'}
          label={'직장전화'}
          format="phone"
          value={wkplTelNo}
          onChange={value => handleChange('wkplTelNo', value)}
        />
      </div>

      <SatModal
        readOnly={isContactReadOnly}
        visible={emailPopupVisible}
        setVisible={() => setEmailPopupVisible(false)}
        type="info"
        wide
      >
        <ChangeCustomerEmail
          emailAddr={emailAddr}
          onChange={handleInputEmailAddr}
        />
      </SatModal>

      <SatModal visible={isCustomerModifytSendSms} type="confirm">
        <>
          <header className="modal-header">
            <h3 className="layer-tit2">고객 정보 변경 SMS 발송</h3>
          </header>
          <div className="cont">
            <SatInput
              value={name}
              label="고객명"
              readOnly
              onChange={() => {}}
              bold
            />

            <SatInput
              value={customerModifySmsParamObject.mobileTelNo}
              type="number"
              customStyleClass={'mgt-8'}
              label="sms 수신 휴대전화번호"
              onChange={value =>
                setCustomerModifySmsParamObject(prev => ({
                  ...prev,
                  mobileTelNo: value,
                }))
              }
              bold
              border
              maxLength={11}
              useMobile
              suffix={() =>
                isNil(mobileTelNo) ? (
                  <></>
                ) : (
                  <button
                    type="button"
                    className="ico ico-del on"
                    onClick={() =>
                      setCustomerModifySmsParamObject(prev => ({
                        custNo: prev.custNo,
                        mobileTelNo: '',
                      }))
                    }
                  />
                )
              }
            />
          </div>

          <div className="btn-group">
            <SatButton
              styleClass="btn-half cancel"
              label="취소"
              onClick={() => setCustomerModifySendSms(false)}
            />
            <SatButton
              styleClass="btn-half confirm"
              label="발송"
              onClick={() =>  
                sendCustomerInfoModifyUrl({
                  custNo: customerModifySmsParamObject.custNo, 
                  mobileTelNo: customerModifySmsParamObject.mobileTelNo, 
                  callback: () => {setCustomerModifySendSms(false)},
                })
              }
            />
          </div>
        </>
      </SatModal>
    </React.Fragment>
  );
};

export default ContactInfo;
